import React from 'react';

import {useTranslation} from 'react-i18next';
import {Redirect, Route, Switch, useLocation} from 'react-router-dom';

import {PageHeader} from '@/widgets/PageHeader';
import {ROUTES} from '@app/routing';
import {Page} from '@shared/ui/Page';
import {RouterTab, RouterTabList} from '@shared/ui/RouterTabs';

import {TabsContentCard, Wrapper} from './styled';
import {ViolationThresholdsTab} from './ui/CatalogsTabs/ViolationThresholdsTab';
import {ViolationTypesTab} from './ui/CatalogsTabs/ViolationTypesTab';
import {DocumentTemplateDetails, MessageTemplateDetails} from './ui/DocumentTemplateDetails';
import {DocumentTemplatesTab} from './ui/DocumentTemplatesTab';
import {JobTemplateDetails} from './ui/JobTemplateDetails';
import {JobTemplatesTab} from './ui/JobTemplatesTab';

export const PreferencesPage = () => {
    const {t} = useTranslation();
    const {pathname} = useLocation();

    return (
        <Page title={t('menu.preferences')}>
            <Wrapper>
                <PageHeader title={t('menu.preferences')} />

                <TabsContentCard>
                    <RouterTabList baseUrl={ROUTES.PREFERENCES_REGISTERS}>
                        <RouterTab
                            url="document-templates"
                            forceActive={pathname.startsWith('/preferences/document-templates')}
                        >
                            {t('page_audit.page_dda.tabs.document-templates')}
                        </RouterTab>
                        <RouterTab
                            url="job-templates"
                            forceActive={pathname.startsWith('/preferences/job-templates')}
                        >
                            {t('page_audit.page_dda.tabs.task-templates')}
                        </RouterTab>
                        <RouterTab
                            url="catalogs"
                            forceActive={pathname.startsWith(ROUTES.PREFERENCES_CATALOGS)}
                        >
                            {t('page_audit.page_dda.tabs.reference-lists')}
                        </RouterTab>
                    </RouterTabList>
                </TabsContentCard>

                <Switch>
                    <Route path={ROUTES.PREFERENCES} exact>
                        <Redirect to={ROUTES.PREFERENCES_DOCUMENT_TEMPLATES} />
                    </Route>
                    <Route path={ROUTES.PREFERENCES_REGISTERS} exact>
                        <Redirect to={ROUTES.PREFERENCES_DOCUMENT_TEMPLATES} />
                    </Route>
                    <Route path={ROUTES.PREFERENCES_DOCUMENT_TEMPLATES} exact>
                        <DocumentTemplatesTab />
                    </Route>
                    <Route path={ROUTES.PREFERENCES_DOCUMENT_TEMPLATE_DETAILS} exact>
                        <DocumentTemplateDetails />
                    </Route>
                    <Route path={ROUTES.PREFERENCES_MESSAGE_TEMPLATE_DETAILS} exact>
                        <MessageTemplateDetails />
                    </Route>
                    <Route path={ROUTES.PREFERENCES_JOB_TEMPLATES} exact>
                        <JobTemplatesTab />
                    </Route>
                    <Route path={ROUTES.PREFERENCES_JOB_TEMPLATE_DETAILS} exact>
                        <JobTemplateDetails />
                    </Route>
                    <Route path={ROUTES.PREFERENCES_CATALOGS}>
                        <CatalogsTabs />
                    </Route>
                    <Route path="*">
                        <Redirect to={ROUTES.PREFERENCES_DOCUMENT_TEMPLATES} />
                    </Route>
                </Switch>
            </Wrapper>
        </Page>
    );
};

const CatalogsTabs = () => {
    const {t} = useTranslation();

    return (
        <Wrapper>
            <TabsContentCard>
                <RouterTabList baseUrl={ROUTES.PREFERENCES_CATALOGS}>
                    <RouterTab url="violation-thresholds">
                        {t('page_audit.page_catalogs.violation-thresholds.title')}
                    </RouterTab>
                    <RouterTab url="violation-types">
                        {t('page_audit.page_catalogs.violation-types.title')}
                    </RouterTab>
                </RouterTabList>
            </TabsContentCard>

            <Switch>
                <Route path={ROUTES.PREFERENCES_CATALOGS} exact>
                    <Redirect to={ROUTES.PREFERENCES_VIOLATION_THRESHOLDS} />
                </Route>
                <Route path={ROUTES.PREFERENCES_VIOLATION_THRESHOLDS} exact>
                    <ViolationThresholdsTab />
                </Route>
                <Route path={ROUTES.PREFERENCES_VIOLATION_TYPES} exact>
                    <ViolationTypesTab />
                </Route>
                <Route path="*">
                    <Redirect to={ROUTES.PREFERENCES_VIOLATION_THRESHOLDS} />
                </Route>
            </Switch>
        </Wrapper>
    );
};
